import React, {useCallback, useEffect, useState} from 'react';
import {UserList} from "../../../components/admin/user/UserList";
import {BoxTitle} from "../../../components/admin/BoxTitle";
import {defaultPagination} from "../../../types/PaginationType";
import {user} from "../../../models/user";
import {ApiQueryParam, ApiService, sort} from "../../../service/ApiService";
import {userResultCollectionType, userResultType} from "../../../types/Api/UserResultType";
import {userHydrator} from "../../../models/hydrator/userHydrator";
import {Pagination} from "../../../components/admin/Pagination";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../service/ToolsService";

export const List = () => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sort, setSort] = useState({by: 'username', direction: 'ASC'} as sort);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);
  const [users, setUsers] = useState([] as user[]);

  const findUser = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort(sort);
    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);
    const result: Promise<userResultCollectionType> = ApiService.get('/user', apiFilters) as Promise<userResultCollectionType>;
    result
      .then((r: userResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setUsers(r._embedded.users.map((user: userResultType) => {
          return userHydrator.hydrate(user);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")

        setPagination(defaultPagination);
        setUsers([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [sort, page, count]);

  useEffect(() => {
    findUser();
  }, [findUser]);

  return (
    <>
      <BoxTitle title="Gestion des utilisateurs" />
      <UserList users={users} loading={loading} refresh={findUser} sort={sort}
                order={(s: string) => {
                  setSort({
                    by: s,
                    direction: (s !== sort?.by || sort.direction === 'DESC') ? 'ASC' : 'DESC'
                  })
                }} />
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
      <div className="mt-3 text-end">
        <NavLink to={`/admin/user/add`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter un utilisateur
        </NavLink>
      </div>
    </>
  )
}